import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

const initialState = {
  activeTab: "Home",
};

// Async thunk for sending reset link

// Create the slice
const tabSlice = createSlice({
  name: "activetab",
  initialState,
  reducers: {
    setActive: (state, action) => {
      state.activeTab = action.payload;
    },
  },
});

// Export actions and reducer
export const { setActive } = tabSlice.actions;
export default tabSlice.reducer;

// Login action
